import PropTypes from 'prop-types'
import React from 'react'

import { libraryPropTypes, resourceTypeUrlMapping } from '../../../utils/libraryTools'
import ResourceLink from './ResourceLink'

const ResourceList = ({ className, resources, meta, onProtocolClick }) => {
  return (
    <div
      className={`${className} px-2.5 sm:px-5 xl:px-10 pb-10 pt-7 border-l border-rule-grey xl:bg-[#F5F7F8]`}
    >
      <div className="text-lg pb-6 hidden md:block">{meta.count.all} Items</div>
      <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
        {resources &&
          resources.map((resource) => {
            const resourceType = resourceTypeUrlMapping[resource.categorySlug]
            return (
              <div className="sm:max-w-[350px] w-full" key={resource._id}>
                <article className="bg-white">
                  <ResourceLink
                    slug={resource.slug.current}
                    title={resource.title}
                    resourceType={resourceType}
                    category={resource.category}
                    thumbnailImage={resource.thumbnailImage}
                    onProtocolClick={onProtocolClick}
                  />
                </article>
              </div>
            )
          })}
      </div>
    </div>
  )
}

ResourceList.defaultProps = {
  className: '',
}

ResourceList.propTypes = {
  className: PropTypes.string,
  libraryType: PropTypes.oneOf(['public', 'professional']).isRequired,
  // searchOptions: libraryPropTypes.searchOptions.isRequired,
  meta: libraryPropTypes.meta.isRequired,
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ResourceList
